export default __webpack_public_path__ + "static/media/pic3.2d0ea429.png";